import { render, staticRenderFns } from "./page009.vue?vue&type=template&id=626e8dc8&scoped=true&"
import script from "./page009.vue?vue&type=script&lang=js&"
export * from "./page009.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e8dc8",
  null
  
)

export default component.exports